var React = require('react');

function Marker (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.1897 47.1325L17.9091 46.6724L17.3999 46.496C8.10373 43.2765 1.5 34.7002 1.5 24.6744C1.5 11.9219 12.1962 1.5 25.4989 1.5C38.6928 1.5 49.3245 11.752 49.4978 24.3613V24.6744C49.4978 34.7004 42.894 43.2785 33.5982 46.4959L33.0888 46.6723L32.8082 47.1325L25.4989 59.1189L18.1897 47.1325Z","fill":"currentColor","strokeWidth":"4"}));
}

Marker.defaultProps = {"viewBox":"0 0 51 62","className":"stroke-black","fill":"none"};

module.exports = Marker;

Marker.default = Marker;
